import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 py-6">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=2200&q=80"
          alt="Athletes training on a sports field"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/65 to-accent/40" />
      </div>

      <div className="relative z-10 grid w-full max-w-6xl items-center gap-10 lg:grid-cols-[1fr_minmax(440px,620px)]">
        <div className="hidden max-w-xl text-white lg:block">
          <p className="mb-4 inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-semibold uppercase tracking-wide backdrop-blur-md">
            Beauty Sports
          </p>
          <h1 className="text-5xl font-extrabold leading-tight">
            Gear up for every win.
          </h1>
          <p className="mt-5 text-lg font-medium leading-8 text-white/80">
            Sign in to manage orders, save favorites, and shop premium sports essentials made for everyday athletes.
          </p>
        </div>

        <div className="w-full">
          <div className="rounded-[var(--radius-lg)] border border-white/20 bg-white/95 p-6 shadow-2xl backdrop-blur-md">
            <Outlet />
          </div>
          <p className="mt-4 text-center text-sm text-white/75">
            (c) {new Date().getFullYear()} Beauty Sports. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
